import { useTranslations } from 'next-intl';

export default function EmptyLeaderboardBody() {
  const t = useTranslations();
  return (
    <div className="flex w-full flex-col items-center justify-center gap-5 py-[150px]">
      <img
        src="/assets/images/leaderboard/empty-leaderboard.svg"
        alt="empty"
        className="h-[110px] w-[110px]"
      />
      <div className="text-text300 text-base font-semibold">
        {t('empty_leaderboard_title')}
      </div>
    </div>
  );
}
